module.exports = __webpack_public_path__ + "img/电器-电机.84f835b4.jpg";